import { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const MaskedDateInput = forwardRef(({ onBlur, onBlurInput, onChange, value, ...props }, ref) => {
  const [displayValue, setDisplayValue] = useState(value ?? '');

  useEffect(() => {
    setDisplayValue(value ?? '');
  }, [value]);

  const handleChange = (event) => {
    const sanitized = event.target.value.replace(/[^\d/]/g, '');

    // A full date is 8 digits, so reject digits past that.
    if (sanitized.replace(/\D/g, '').length > 8) {
      event.target.value = displayValue;
      return;
    }

    event.target.value = sanitized;
    setDisplayValue(sanitized);
    onChange?.(event);
  };

  const handleBlur = (event) => {
    onBlur?.(event);

    // Skip the picker's lenient commit. Let react-datepicker's pick win.
    if (event.relatedTarget?.closest?.('.react-datepicker')) return;

    const committed = onBlurInput?.(event);
    if (typeof committed === 'string') setDisplayValue(committed);
  };

  return (
    <input {...props} onBlur={handleBlur} onChange={handleChange} ref={ref} value={displayValue} />
  );
});

MaskedDateInput.displayName = 'MaskedDateInput';

MaskedDateInput.propTypes = {
  onBlur: PropTypes.func,
  onBlurInput: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default MaskedDateInput;
